import { Outlet } from 'react-router-dom'

import SectionContainer from 'modules/core/components/SectionContainer'

import CollectionsBootstrap from 'modules/marketplace/lib/CollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <SectionContainer>
        <Outlet />
      </SectionContainer>
    </CollectionsBootstrap>
  )
}

export default RootPage
